import { MessageBubble } from "@twilio/flex-webchat-ui";
import React from "react";
import ReactMarkdown from "react-markdown";
import nl2br from "react-nl2br";
import { buttonsRegex, inputHiddenRegex } from '../utils/messageRegex';
import { AttachmentMessage } from "./AttachmentMessage";
import { MessageBubbleButtons } from "./MessageBubbleButtons";

export class CustomMessageBubble extends MessageBubble {
  state = {
    bodyProps: {},
  };

  async componentDidMount() {
    const bodyPropsReceived = this._getBodyProps();
    this.setState({ bodyProps: bodyPropsReceived });

    await this.delay(300)
    this.scrollToBottom()
    this.disabledMessageButtons()
  }

  getLastRepliedIndex() {
    const repliedIndexList = []
    if (this.props.message.source.channel) {
      this.props.message.source.channel.messagesEntity.messagesByIndex._c.forEach((message) => {
        if (!(message.attributes?.lastRepliedMessage >= 0)) return
        repliedIndexList.push(message.attributes?.lastRepliedMessage)
      })
    }
    return repliedIndexList.sort((a ,b) => b - a)[0]
  }

  disabledMessageButtons() {
    const lastIndex = this.getLastRepliedIndex()
    if (!lastIndex) return
    let lastConsumedMessageIndex = this.props.message.source?.channel?.channelState.lastMessage.index
    const messageContainerElement = document && document.querySelector(".Twilio-MessageList")
    if (!messageContainerElement) return
    const messageItemsContainerElement = messageContainerElement && messageContainerElement.querySelectorAll(".Twilio-MessageListItem")
    const messageItemsList = [...messageItemsContainerElement]
    messageItemsList.reverse()
    messageItemsList.forEach((el) => {
      if(lastConsumedMessageIndex >= lastIndex) {
        lastConsumedMessageIndex--
        return
      }
      const buttonElement = el.querySelectorAll('.button-options__button')
      if (buttonElement) {
          buttonElement.forEach(element => {
              element.style.opacity = 0.5
              element.style['pointer-events'] = "none"
          })
      }
      lastConsumedMessageIndex--
    })
  }

  scrollToBottom() {
    document.querySelector('.Twilio-MessageList').scrollTo({
      top: 999999,
      behavior: 'smooth'
    })
  }

  delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  getCustomName (name) {
    return name === 'Deco – Assistente Virtual da Mobly' ? name : 'Atendimento Mobly'
  }

  render() {
    const { message, channelSid } = this.props;

    const renderbodyProps = this.state.bodyProps;
    return (
      <div className='Twilio Twilio-MessageBubble'>
        <div className='Twilio-MessageBubble-default'>
          <div className='Twilio-MessageBubble-Header'>
            <div className='Twilio-MessageBubble-UserName'>
              { message.isFromMe ? "" : this.getCustomName(this.props.member.friendlyName) }
            </div>
          </div>
          <div className='Twilio-MessageBubble-Body' {...renderbodyProps} />
          <MessageBubbleButtons
            manager={this.props.manager}
            channelSid={channelSid}
            message={message}
          />
        </div>
        <div className='Twilio-MessageBubble-end'>
          <div className='Twilio-MessageBubble-Time'>
            {message.source.timestamp.toLocaleTimeString("pt-BR", {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </div>
        </div>
      </div>
    );
  }

  _getBodyProps = () => {
    const { message } = this.props;
    const { media } = message.source;
    const bodyProps = {
      children: message.source.body,
    };

    if (media) {
      bodyProps.children = <AttachmentMessage {...this.props} />;
    } else {
      if (!message.isFromMe) {
        let { body } = message.source;
        
        body = body.replace(buttonsRegex, "");
        body = body.replace(inputHiddenRegex, "");
        body = [body.trim()];
        body = this._renderMarkdown(body);
        bodyProps.children = body;
      } else {
        bodyProps.children = nl2br(bodyProps.children);
      }
    }

    return bodyProps;
  };

  _renderMarkdown = (value) => {
    return value.map((item, index) => {
      if (typeof item === "string") {
        return (
          <ReactMarkdown key={index} linkTarget='_blank'>
            {item}
          </ReactMarkdown>
        );
      }
      return item;
    });
  };
}
